// import { useEffect, useState } from "react";
// import { useLocation, useParams } from "react-router-dom";
// import useScrollToTop from "hooks/useScrollToTop";
// import LoaderSpiner from "Components/LoaderSpiner";
// import { BASE_APIURL } from "utils/helpers";
// import DOMPurify from "dompurify";
// import "./BlogDetail.css";

// const CACHE_KEY = "cachedBlogs";

// //read cache safely
// const getCachedBlogs = () => {
//   try {
//     const data = localStorage.getItem(CACHE_KEY);
//     return data ? JSON.parse(data) : {};
//   } catch {
//     return {};
//   }
// };

// //Save or update blog in cache
// const saveBlogToCache = (blog) => {
//   const id = blog.id || blog._id || blog.key;
//   if (!id) {
//     console.warn("⚠️ Blog missing ID, skipping cache:", blog);
//     return;
//   }
//   const cache = getCachedBlogs();
//   cache[blog.id] = {
//     ...blog,
//     cachedAt: Date.now(),
//   };
//   localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
//   // Notify other tabs that cache changed
//   window.dispatchEvent(new Event("blogCacheUpdated"));
//     console.log("✅ Saved blog to cache:", id, blog.title);

// };

// //Find blog by ID or title slug
// const findBlogInCache = (slug, id) => {
//   const cache = getCachedBlogs();
//   if (id && cache[id]) return cache[id];
//   const normalized = slug.replace(/-/g, " ").toLowerCase();
//   return Object.values(cache).find(
//     (b) => b.title.toLowerCase() === normalized
//   );
// };

// //Auto-clean old cache entries (>7 days)
// const cleanOldCache = () => {
//   const cache = getCachedBlogs();
//   const now = Date.now();
//   const filtered = Object.fromEntries(
//     Object.entries(cache).filter(
//       ([, v]) => now - v.cachedAt < 7 * 24 * 60 * 60 * 1000
//     )
//   );
//   localStorage.setItem(CACHE_KEY, JSON.stringify(filtered));
// };

// //limit cache size (keep 10 most recent)
// const limitCacheSize = (max = 10) => {
//   const cache = getCachedBlogs();
//   const entries = Object.entries(cache)
//     .sort(([, a], [, b]) => b.cachedAt - a.cachedAt)
//     .slice(0, max);
//   localStorage.setItem(CACHE_KEY, JSON.stringify(Object.fromEntries(entries)));
// };

// const BlogDetail = () => {
//   useScrollToTop();

//   const { slug } = useParams();
//   const location = useLocation();
//   console.log("location data" , location.state);

//   const idFromState = location.state?.id;
//   const blogFromState = location.state?.blog;

//   const [blogData, setBlogData] = useState(blogFromState || null);
//   const [loading, setLoading] = useState(!blogFromState);
//   const [error, setError] = useState(null);

//   //Listen for cache updates from other tabs
//   useEffect(() => {
//     const handleCacheUpdate = () => {
//       const cached = findBlogInCache(slug, idFromState);
//       if (cached && !blogData) {
//         setBlogData(cached);
//         setLoading(false);
//       }
//     };

//     window.addEventListener("storage", handleCacheUpdate);
//     window.addEventListener("blogCacheUpdated", handleCacheUpdate);
//     return () => {
//       window.removeEventListener("storage", handleCacheUpdate);
//       window.removeEventListener("blogCacheUpdated", handleCacheUpdate);
//     };
//   }, [slug, idFromState, blogData]);

//   //Main blog fetching logic
//   useEffect(() => {
//     cleanOldCache();

//     // Try local cache first
//     const cachedBlog = findBlogInCache(slug, idFromState);
//     if (cachedBlog && !blogData) {
//       setBlogData(cachedBlog);
//       setLoading(false);
//       return;
//     }

//     const fetchBlog = async () => {
//       try {
//         let response, post;

//         if (idFromState) {
//           response = await fetch(`${BASE_APIURL}/api/blogs/post/id/${idFromState}`);
//           if (!response.ok) throw new Error("Failed to fetch blog by ID");
//           const data = await response.json();
//           post = data.post;
//         } else {
//           const readableTitle = slug.replace(/-/g, " ");
//           response = await fetch(
//             `${BASE_APIURL}/api/blogs/post/title/${encodeURIComponent(readableTitle)}`
//           );
//           if (!response.ok) throw new Error("Fetch by title failed");
//           const data = await response.json();
//           post = data.posts?.[0] || null;
//         }

//         if (post) {
//             console.log("✅ Saving blog to cache:", post.id, post.title);

//           setBlogData(post);
//           saveBlogToCache(post);
//           limitCacheSize(); // keep cache small
//         } else {
//           setError("Blog not found");
//         }
//       } catch (err) {
//         console.error("Error fetching blog:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (!blogData) {
//       fetchBlog();
//     }
//   }, [slug]);

//   if (loading) return <LoaderSpiner />;
//   if (error) return <p className="text-red-500 text-center mt-8">{error}</p>;
//   if (!blogData || !blogData.content)
//     return (
//       <p className="text-gray-500 text-center mt-8">
//         Blog content not found.
//       </p>
//     );

//   const sanitizedContent = DOMPurify.sanitize(blogData.content);

//   return (
//     <div
//       style={{ width: "80%", margin: "0 auto", textAlign: "center" }}
//       className="blogs-container"
//     >
//       <div
//         style={{
//           marginTop: "20px",
//           padding: "20px",
//           textAlign: "left",
//           borderBottom: "1px solid #ccc",
//           maxWidth: "1000px",
//           margin: "20px auto",
//         }}
//         className="PlaygroundEditorTheme custom-blog-content"
//       >
//         {/* Blog Title */}
//         <h1 className="text-3xl font-bold mb-4">{blogData.title}</h1>

//         {/* Thumbnail */}
//         {blogData.thumbnail && (
//           <img
//             src={blogData.thumbnail}
//             alt={blogData.title}
//             className="w-full rounded-lg mb-6"
//           />
//         )}

//         {/* Blog Content */}
//         <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
//       </div>
//     </div>
//   );
// };

// export default BlogDetail;

// fetch blog by id or title slug

// import { useEffect, useState } from "react";
// import { useLocation, useParams } from "react-router-dom";
// import useScrollToTop from "hooks/useScrollToTop";
// import LoaderSpiner from "Components/LoaderSpiner";
// import { BASE_APIURL } from "utils/helpers";
// import DOMPurify from "dompurify";
// import "./BlogDetail.css";

// /** ---------- Local Cache Utilities ---------- **/
// const CACHE_KEY = "cachedBlogs";
// const MAX_CACHE_SIZE = 10;
// const CACHE_TTL = 7 * 24 * 60 * 60 * 1000; // 7 days

// const getCachedBlogs = () => {
//   try {
//     const data = localStorage.getItem(CACHE_KEY);
//     console.log("🔹 getCachedBlogs:", data);
//     return data ? JSON.parse(data) : {};
//   } catch (err) {
//     console.error("❌ getCachedBlogs failed:", err);
//     return {};
//   }
// };

// const saveBlogToCache = (blog) => {
//   const id = blog.id || blog._id || blog.key;
//   if (!id) {
//     console.warn("⚠️ Blog missing ID, skipping cache:", blog);
//     return;
//   }

//   const cache = getCachedBlogs();
//   cache[id] = { ...blog, cachedAt: Date.now() };

//   const entries = Object.entries(cache)
//     .sort(([, a], [, b]) => b.cachedAt - a.cachedAt)
//     .slice(0, MAX_CACHE_SIZE);

//   localStorage.setItem(CACHE_KEY, JSON.stringify(Object.fromEntries(entries)));
//   console.log("✅ Saved blog to cache:", id, blog.title);
//   window.dispatchEvent(new Event("blogCacheUpdated"));
// };

// const findBlogInCache = (slug, id) => {
//   const cache = getCachedBlogs();
//   console.log("🔹 findBlogInCache: cache keys:", Object.keys(cache));
//   if (id && cache[id]) {
//     console.log("🔹 Blog found in cache by ID:", id);
//     return cache[id];
//   }

//   const normalizedSlug = slug.replace(/-/g, " ").toLowerCase();
//   const found = Object.values(cache).find((b) => b.title?.toLowerCase() === normalizedSlug);
//   console.log("🔹 Blog found in cache by slug:", found);
//   return found;
// };

// const cleanOldCache = () => {
//   const cache = getCachedBlogs();
//   const now = Date.now();
//   const filtered = Object.fromEntries(
//     Object.entries(cache).filter(([, v]) => now - v.cachedAt < CACHE_TTL)
//   );
//   localStorage.setItem(CACHE_KEY, JSON.stringify(filtered));
//   console.log("🧹 Cleaned old cache. Remaining keys:", Object.keys(filtered));
// };

// /** ---------- Component ---------- **/
// const BlogDetail = () => {
//   useScrollToTop();
//   const { slug } = useParams();
//   const location = useLocation();

//   console.log("🔹 BlogDetail loaded with slug:", slug);
//   console.log("🔹 Location state:", location.state);

//   const idFromState = location.state?.id;
//   const blogFromState = location.state?.blog;

//   const [blogData, setBlogData] = useState(blogFromState || null);
//   const [loading, setLoading] = useState(!blogFromState);
//   const [error, setError] = useState(null);

//   console.log("🔹 Initial blogData:", blogData);
//   console.log("🔹 Initial loading:", loading);

//   /** Listen for cross-tab cache updates **/
//   useEffect(() => {
//     const handleCacheUpdate = () => {
//       const cached = findBlogInCache(slug, idFromState);
//       console.log("🔄 Cache update event fired:", cached);
//       if (cached && (!blogData || !blogData.content)) {
//         console.log("🔹 Updating blogData from cache due to update event");
//         setBlogData(cached);
//         setLoading(false);
//       }
//     };

//     window.addEventListener("storage", handleCacheUpdate);
//     window.addEventListener("blogCacheUpdated", handleCacheUpdate);
//     return () => {
//       window.removeEventListener("storage", handleCacheUpdate);
//       window.removeEventListener("blogCacheUpdated", handleCacheUpdate);
//     };
//   }, [slug, idFromState, blogData]);

//   /** Main fetch logic **/
//   useEffect(() => {
//     console.log("🔹 useEffect: fetching blog for slug:", slug, "id:", idFromState);
//     cleanOldCache();

//     const cachedBlog = findBlogInCache(slug, idFromState);
//     console.log("🔹 Cached blog check:", cachedBlog);

//     if (cachedBlog && (!blogData || !blogData.content)) {
//       console.log("🔹 Using cached blog");
//       setBlogData(cachedBlog);
//       setLoading(false);
//       return;
//     }

//     if (blogData && blogData.content) {
//       console.log("🔹 BlogData already has content, skipping fetch");
//       setLoading(false);
//       return;
//     }

//     const fetchBlog = async () => {
//       setLoading(true);
//       try {
//         let post;

//         if (idFromState) {
//           console.log("🔹 Fetching blog by ID:", idFromState);
//           const response = await fetch(`${BASE_APIURL}/api/blogs/post/id/${idFromState}`);
//           console.log("🔹 Response status:", response.status);
//           if (!response.ok) throw new Error("Failed to fetch blog by ID");
//           const data = await response.json();
//           console.log("🔹 Response data (by ID):", data);
//           post = data.post;
//         } else {
//           const readableTitle = slug.replace(/-/g, " ");
//           console.log("🔹 Fetching blog by title:", readableTitle);
//           const response = await fetch(`${BASE_APIURL}/api/blogs/post/title/${encodeURIComponent(readableTitle)}`);
//           console.log("🔹 Response status:", response.status);
//           if (!response.ok) throw new Error("Fetch by title failed");
//           const data = await response.json();
//           console.log("🔹 Response data (by title):", data);
//           post = data.posts?.[0] || null;
//         }

//         if (post) {
//           console.log("✅ Fetched blog data:", post);
//           setBlogData(post);
//           saveBlogToCache(post);
//         } else {
//           console.warn("⚠️ Blog not found in backend");
//           setError("Blog not found");
//         }
//       } catch (err) {
//         console.error("❌ Error fetching blog:", err);
//         setError(err.message);
//       } finally {
//         console.log("🔹 Fetch blog completed");
//         setLoading(false);
//       }
//     };

//     fetchBlog();
//   }, [slug, idFromState, blogData]);

//   /** ---------- Render ---------- **/
//   if (loading) {
//     console.log("🔹 Rendering loader...");
//     return <LoaderSpiner />;
//   }

//   if (error) {
//     console.log("⚠️ Rendering error:", error);
//     return <p className="text-red-500 text-center mt-8">Error: {error}</p>;
//   }

//   if (!blogData || !blogData.content) {
//     console.log("⚠️ Rendering blog not found");
//     return <p className="text-gray-500 text-center mt-8">Blog content not found.</p>;
//   }

//   console.log("🔹 Rendering blog content:", blogData.title);

//   const sanitizedContent = DOMPurify.sanitize(blogData.content);

//   return (
//     <div className="blogs-container mx-auto text-center w-4/5">
//       <div className="PlaygroundEditorTheme custom-blog-content mx-auto max-w-3xl mt-5 p-6 text-left border-b border-gray-300">
//         <h1 className="text-3xl font-bold mb-4">{blogData.title}</h1>

//         {blogData.thumbnail && (
//           <img
//             src={blogData.thumbnail}
//             alt={blogData.title}
//             className="w-full rounded-lg mb-6"
//           />
//         )}

//         <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
//       </div>
//     </div>
//   );
// };

// export default BlogDetail;

// fet blog by key
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import useScrollToTop from "hooks/useScrollToTop";
import LoaderSpiner from "Components/LoaderSpiner";
import { BASE_APIURL } from "utils/helpers";
import DOMPurify from "dompurify";
import "./BlogDetail.css";

const CACHE_KEY = "cachedBlogs";
const MAX_CACHE_SIZE = 10;
const CACHE_TTL = 7 * 24 * 60 * 60 * 1000; // 7 days

const getCachedBlogs = () => {
  try {
    const data = localStorage.getItem(CACHE_KEY);
    return data ? JSON.parse(data) : {};
  } catch (err) {
    console.error("getCachedBlogs failed:", err);
    return {};
  }
};

const saveBlogToCache = (blog) => {
  const key = blog.key;
  if (!key) {
    // console.warn("Blog missing key, skipping cache:", blog);
    return;
  }

  const cache = getCachedBlogs();
  cache[key] = { ...blog, cachedAt: Date.now() };

  const entries = Object.entries(cache)
    .sort(([, a], [, b]) => b.cachedAt - a.cachedAt)
    .slice(0, MAX_CACHE_SIZE);

  localStorage.setItem(CACHE_KEY, JSON.stringify(Object.fromEntries(entries)));
  // console.log("✅ Saved blog to cache:", key, blog.title);
  window.dispatchEvent(new Event("blogCacheUpdated"));
};

const findBlogInCache = (slug, key) => {
  const cache = getCachedBlogs();
  // console.log("findBlogInCache: cache keys:", Object.keys(cache));
  if (key && cache[key]) {
    // console.log("Blog found in cache by key:", key);
    return cache[key];
  }

  const normalizedSlug = slug.replace(/-/g, " ").toLowerCase();
  const found = Object.values(cache).find(
    (b) => b.title?.toLowerCase() === normalizedSlug
  );
  // console.log("🔹 Blog found in cache by slug:", found);
  return found;
};

const cleanOldCache = () => {
  const cache = getCachedBlogs();
  const now = Date.now();
  const filtered = Object.fromEntries(
    Object.entries(cache).filter(([, v]) => now - v.cachedAt < CACHE_TTL)
  );
  localStorage.setItem(CACHE_KEY, JSON.stringify(filtered));
  // console.log("Cleaned old cache. Remaining keys:", Object.keys(filtered));
};

const BlogDetail = () => {
  useScrollToTop();
  const { slug } = useParams();
  const location = useLocation();

  // UUID is the last 5 dash-separated parts
  const idParts = slug.split("-");
  const id = idParts.slice(-5).join("-");

  // console.log("BlogDetail mounted. Slug:", slug);
  // console.log("Location state:", location.state);

  const keyFromState = location.state?.blog?.key;
  const blogFromState = location.state?.blog;

  const [blogData, setBlogData] = useState(blogFromState || null);
  const [loading, setLoading] = useState(!blogFromState);
  const [error, setError] = useState(null);

  // console.log("Initial blogData state:", blogData);
  // console.log("Initial loading state:", loading);

  /** Listen for cross-tab cache updates **/
  useEffect(() => {
    const handleCacheUpdate = () => {
      const cached = findBlogInCache(slug, keyFromState);
      // console.log("Cache update event fired:", cached);
      if (cached && (!blogData || !blogData.content)) {
        // console.log("Updating blogData from cache due to update event");
        setBlogData(cached);
        setLoading(false);
      }
    };

    window.addEventListener("storage", handleCacheUpdate);
    window.addEventListener("blogCacheUpdated", handleCacheUpdate);
    return () => {
      window.removeEventListener("storage", handleCacheUpdate);
      window.removeEventListener("blogCacheUpdated", handleCacheUpdate);
    };
  }, [slug, keyFromState, blogData]);

  /** Main fetch logic **/
  useEffect(() => {
    // console.log("useEffect: fetching blog for slug:",slug,"key:",keyFromState);
    cleanOldCache();

    const cachedBlog = findBlogInCache(slug, keyFromState);
    // console.log("Cached blog check:", cachedBlog);

    if (cachedBlog && (!blogData || !blogData.content)) {
      // console.log("Using cached blog");
      setBlogData(cachedBlog);
      setLoading(false);
      return;
    }

    if (blogData && blogData.content) {
      // console.log("BlogData already has content, skipping fetch");
      setLoading(false);
      return;
    }

    const fetchBlog = async () => {
      setLoading(true);
      try {
        let post;
        //blog key
        if (keyFromState) {
          // console.log("Fetching blog by key:", keyFromState);
          const response = await fetch(
            `${BASE_APIURL}/api/blogs/post/key/${encodeURIComponent(
              keyFromState
            )}`
          );
          // console.log("Response status:", response.status);
          if (!response.ok) throw new Error("Failed to fetch blog by key");
          const data = await response.json();
          // console.log("Response data (by key):", data);
          post = data.post;
        } else if (id) {
          const response = await fetch(
            `${BASE_APIURL}/api/blogs/post/id/${id}`
          );
          if (!response.ok) throw new Error("Failed to fetch blog by ID");
          const data = await response.json();
          post = data.post;
        } else {
          const readableTitle = slug.replace(/-/g, " ");

          // console.log("Fetching blog by title:", readableTitle);
          const response = await fetch(
            `${BASE_APIURL}/api/blogs/post/title/${encodeURIComponent(
              readableTitle
            )}`
          );
          // console.log("Response status:", response.status);
          if (!response.ok) throw new Error("Fetch by title failed");
          const data = await response.json();
          // console.log("Response data (by title):", data);
          post = data.posts?.[0] || null;
        }

        if (post) {
          // console.log("Fetched blog data:", post);
          setBlogData(post);
          saveBlogToCache(post);
        } else {
          // console.warn("Blog not found in backend");
          setError("Blog not found");
        }
      } catch (err) {
        console.error("Error fetching blog:", err);
        setError(err.message);
      } finally {
        // console.log("Fetch blog completed");
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug, keyFromState, blogData]);

  /** ---------- Render ---------- **/
  if (loading) {
    // console.log("🔹 Rendering loader...");
    return <LoaderSpiner />;
  }

  if (error) {
    // console.log("⚠️ Rendering error:", error);
    return <p className="text-red-500 text-center mt-8">Error: {error}</p>;
  }

  if (!blogData || !blogData.content) {
    // console.log("⚠️ Rendering blog not found");
    return (
      <p className="text-gray-500 text-center mt-8">Blog content not found.</p>
    );
  }

  // console.log("🔹 Rendering blog content:", blogData.title);

  const sanitizedContent = DOMPurify.sanitize(blogData.content);

  return (
    <div className="blogs-container mx-auto text-center w-4/5">
      <div className="PlaygroundEditorTheme custom-blog-content mx-auto max-w-3xl mt-5 p-6 text-left border-b border-gray-300">
        <h1 className="text-3xl font-bold mb-4">{blogData.title}</h1>

        {blogData.thumbnail && (
          <img
            src={blogData.thumbnail}
            alt={blogData.title}
            className="w-full rounded-lg mb-6"
          />
        )}

        <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
      </div>
    </div>
  );
};

export default BlogDetail;
